import {
  UpdateOperationGqlQuery,
  UpdateOperationGqlStatus,
  FetchOperationsCacheKey,
  OperationBody,
  OperationClientID,
  OperationTeamNanoID,
  OperationCompleteDatetime,
  OperationDate,
  OperationFileAttachmentIDs,
  OperationGqlError,
  OperationState,
  OperationSubject,
  OperationType,
  OperationUUID,
  OperationID
} from '../../operationsTypes';

import { useUpdateQuery } from '../../../common/reactQuery/hooks/useUpdateQuery';

interface UpdateOperationOptions {
  query: UpdateOperationGqlQuery;
  cacheKeys?: FetchOperationsCacheKey[];
}

interface UpdateOperationRecordResponse {
  uuid: OperationUUID;
}

export interface UpdateOperationResponse {
  updateOperation: {
    status: UpdateOperationGqlStatus;
    recordUuid: OperationUUID;
    record: UpdateOperationRecordResponse;
    errors: UpdateOperationError;
  };
}

export interface UpdateOperationInput {
  uuid: OperationID;
  clientId?: OperationClientID;
  teamNanoId?: OperationTeamNanoID;
  subject: OperationSubject;
  body: OperationBody;
  date: OperationDate;
  operationType: OperationType;
  state: OperationState;
  fileAttachmentIds?: OperationFileAttachmentIDs | null;
  completeDatetime?: OperationCompleteDatetime | null;
}

export interface UpdateOperationError {
  clientId: OperationGqlError;
  teamNanoId: OperationGqlError;
  subject: OperationGqlError;
  body: OperationGqlError;
  date: OperationGqlError;
  operationType: OperationGqlError;
  state: OperationGqlError;
  fileAttachmentIds: OperationGqlError;
  fullMessages: OperationGqlError;
}

const action = 'updateOperation';

function useUpdateOperation({ query, cacheKeys }: UpdateOperationOptions) {
  const {
    updateQueryData,
    updateQuery,
    updateQueryReset,
    updateQueryError,
    updateQueryErrorMessage,
    updateQueryLoading
  } = useUpdateQuery<
    UpdateOperationInput,
    UpdateOperationResponse,
    UpdateOperationError,
    UpdateOperationRecordResponse
  >({ action, cacheKeys, query });

  return {
    updateOperationData: updateQueryData,
    updateOperationError: updateQueryError,
    updateOperationLoading: updateQueryLoading,
    updateOperationErrorMessage: updateQueryErrorMessage,
    updateOperation: updateQuery,
    updateOperationReset: updateQueryReset
  };
}

export default useUpdateOperation;
